import axios from "axios";

export const getLoadProductsRequest = () => ({
  method: "get",
  url: `products`,
});

export const getLinkedMarketPlaceProductRequest = (id) => ({
  method: "get",
  url: `products/linkedMarketPlaceProduct/${id}`,
});

export const getVariantRequest = (id) => ({
    method: "get",
    url: `products/variant/${id}`,
  });

  export const setVariantRequest = (data) => ({
    method: "put",
    url: `products/variant/${data.id}`,
    config: {
        data,
      },
  });

export const setProductVariantsRequest = (data) => ({
    method: "post",
    url: `products/variants-bulk-update`,
    config: {
        data,
      },
  });

export const setLinkedMarketPlaceProductRequest = (data) => ({
    method: "post",
    url: `products/linked-marketplace-product`,
    config: {
        data,
      },
  });

  export const setMarketPercentageRequest = (data) => ({
    method: "post",
    url: `marketplaces/price-update`,
    config: {
        data,
      },
  });

  export const setProductStatusRequest = (data) => ({
    method: "post",
    url: `products/updateStatus/${data.status}/${data.id}`,
    config: {
        params: {
            api:'true'
        }
      }
  });

  export const switchVariantStatusRequest = (data) => ({
    method: "post",
    url: `variants/updateStatus/${data.status}/${data.variant_id}`
  });

//   export const listLinkedProductStatusRequest = (data) => ({
//     method: "post",
//     url: `linked_product/${data.linked_market_id}/list_product/${data.variant_id}`,
//     config: {
//         params: {
//             api:'true'
//         }
//       },
//   });

//   export const unlistLinkedProductStatusRequest = (data) => ({
//     method: "post",
//     url: `linked_product/${data.linked_market_id}/unlist_product/${data.variant_id}`,
//     config: {
//         params: {
//             api:'true'
//         }
//       },
//   });

  export const getLoadMarketPlacesRequest = () => ({
    method: "get",
    url: `marketplaces`
  });

